<template>
  <b-row class="justify-content-center m-0">
    <b-col v-if="user" cols="12">
      <feed-post
        v-if="user && $_feedMixin_learningUnit && $_feedMixin_section"
        :learning-unit="$_feedMixin_learningUnit"
        :section="$_feedMixin_section"
        :user="user"
        show-meeting-time
      />
    </b-col>
  </b-row>
</template>

<script>
import { feedMixin } from '@/mixins/feedMixin';
import { userInfoMixin } from '@/mixins/userInfoMixin';
// import BaseBreadCrumb from "@/components/base-components/BaseBreadCrumb";
import FeedPost from './components/FeedPost';
import Section from '@/models/Section';
import { useAuth } from '@/composables/useAuth';
import CatalogProjectActivity from '@/models/catalog/CatalogProjectActivity';
// import LearningUnit from "@/models/LearningUnit";

const { loadUserData } = useAuth();

export default {
  components: { FeedPost },
  mixins: [feedMixin, userInfoMixin],

  data() {
    return {
      loading: false
    };
  },

  // computed: {
  //   breadcrumbs() {
  //     const { $_feedMixin_learningUnit } = this;

  //     return [
  //       {
  //         key: "my-learning-unit",
  //         name: "My Learning Units",
  //         to: {
  //           name: "learning-unit/my-learning-unit",
  //         },
  //       },
  //       {
  //         key: "learning-unit-info",
  //         name: $_feedMixin_learningUnit ? $_feedMixin_learningUnit.name : "",
  //         to: {
  //           name: "learning-unit/info",
  //           params: {
  //             learningUnitId: $_feedMixin_learningUnit
  //               ? $_feedMixin_learningUnit.id
  //               : null,
  //           },
  //         },
  //       },
  //       {
  //         key: "learning-feed",
  //         name: "Learning feed",
  //         active: true,
  //       },
  //     ];
  //   },
  // },

  watch: {
    '$route.path': {
      immediate: true,
      handler: 'onRouteChanged'
    }
  },

  methods: {
    async onRouteChanged(route) {
      console.log(route);

      this.loading = false;

      await this.fetch();

      this.loading = true;
    },

    async fetch() {
      await loadUserData();

      this.logProjectView();

      await Section.api().fetchById(this.$_feedMixin_sectionId);

      // if (
      //   !this.$_feedMixin_section.hasEnrollUser(this.user.uid) ||
      //   !this.$_feedMixin_section.reachStartDate()
      // ) {
      //   const { $_feedMixin_learningUnitId } = this;

      //   return this.$router.push({
      //     name: "learning-unit/info",
      //     params: { learningUnitId: $_feedMixin_learningUnitId },
      //   });
      // }
    },

    // Fire-and-forget: record the learner's first view of this project.
    // Failures are logged but must never block the learning feed from loading.
    logProjectView() {
      CatalogProjectActivity.api()
        .logProjectView(this.$_feedMixin_learningUnitId)
        .catch((error) => console.error('Cannot log project view', error));
    }
  }
};
</script>
